export function HeadingTwo({ children }: { children: React.ReactNode }) {
  return (
    <h2 className="text-xl font-semibold text-gray-900 mb-2">{children}</h2>
  );
}
